import { graphql } from 'gatsby';
import React from 'react';

import Layout from '../components/layout';
import { IPageInfo } from '../components/paginator';
import Feed, { IFeedPostList } from '../components/feed'; // tslint:disable-line: ordered-imports
import SEO from '../components/seo';

interface IBlogIndexProps {
  data: { posts: IFeedPostList };
  pageContext: {
    pageInfo: IPageInfo;
  };
}

function BlogIndex({
  data: { posts },
  pageContext: { pageInfo }
}: IBlogIndexProps) {
  return (
    <Layout>
      <SEO title="Blog" defaultMetaTitle={true} />
      <Feed
        feedPostList={posts}
        pageInfo={pageInfo}
        header="Data Version Control in Real Life"
        leadParagraph={
          <>
            We write about machine learning workflow. From data versioning and
            processing to model productionization. We share our news, findings,
            interesting reads, community takeaways.
          </>
        }
      />
    </Layout>
  );
}

export default BlogIndex;

export const pageQuery = graphql`
  query($skip: Int, $limit: Int) {
    posts: allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { fileAbsolutePath: { regex: "/content/blog/" } }
      skip: $skip
      limit: $limit
    ) {
      ...FeedPostList
    }
  }
`;
